<template>
  <div>
    <c-tab
      type="vertical"
      :tabItems="tabItems"
      :height.sync="height"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
export default {
  name: 'hazop-plan',
  props: {
    popupParam: {
      type: Object,
      default: () => ({

      }),
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      editable: true,
      splitter: 5,
      tab: 'planInfo',
      tabItems: [
        { name: 'planInfo', icon: 'edit', label: '감사계획정보', component: () => import(`${'./planInfo.vue'}`) },
        { name: 'planTeam', icon: 'checklist', label: '감사반', component: () => import(`${'./planTeam.vue'}`) },
        { name: 'planItem', icon: 'category', label: '감사항목', component: () => import(`${'./planItem.vue'}`) },
        { name: 'auditTable', icon: 'table_view', label: '환산표', component: () => import(`${'./auditTable.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
    },
  }
};
</script>
